import React, { Component } from 'react';
import { withRouter } from 'react-router';


import Overview from './job-overview.component';
import Questions from './job-question.component';

// styles and icons
import { Row, Container, Col, Nav, Tab } from 'react-bootstrap';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DescriptionIcon from '@material-ui/icons/Description';
import HelpIcon from '@material-ui/icons/Help';
import './job.style.css';


class CreateJob extends Component {
    constructor(props) {
        super(props);
        this.state = [];
    }
    callBackFun = (data) => {
        if (data) {
            console.log(data);
            localStorage.setItem('updatedJobPost', JSON.stringify(data))
            this.setState({updatedJobPost: data })
        }
    }
    componentDidMount() {
        // get data from props in case of edit job 
        if (this.props.location && this.props.location.state) {
            let data = this.props.location.state
            let tags = data.tags.map(tag=>tag.name);
            console.log(data);
            let filterdData = {
                jobId : data.id,
                brief: data.brif,
                experience: data.job_level_of_experience_type.id,
                jobStatus: data.job_status,
                jobType: data.job_type.id,
                salaryFrom: data.salary.salary_from,
                salaryTo: data.salary.salary_to,
                currency: data.salary.currency_type.id,
                tagsChoosen: tags,
                title: data.title,
                questions : data.questions
            }
            console.log(filterdData)
            localStorage.setItem('updatedJobPost', JSON.stringify(filterdData));
            this.setState({ ...this.state, updatedJobPost: filterdData});
        }
        // get data from localstorage 
        else if (localStorage.getItem('updatedJobPost')) {
            this.setState({ ...this.state, updatedJobPost: JSON.parse(localStorage.getItem('updatedJobPost')), status: "Save Changes" });
        }
        // make all left links disabled 
        let list = document.getElementById("job-tabs");
        let nav_items = list.querySelectorAll(".nav-item a");
        window.setInterval(function () {
            for (let i = 0; i < nav_items.length; i++) {
                nav_items[i].setAttribute("aria-disabled", "true")
                nav_items[i].classList.add("disabled")
            }
        }, 100)
    }
    render() {
        return (
            <div className="createBiography">
                <Container className="pt-4 container-fluid-responsive m-h-100">
                    <Tab.Container defaultActiveKey="first">
                        <Row className="m-0 pt-xs-4">
                            <Col sm={3}>
                                <Nav variant="pills" id="job-tabs" className="flex-column">
                                    <Nav.Item>
                                        <Nav.Link eventKey="first" className="row m-0">
                                            <Row className="m-0">
                                                <Col xs={3} ><DescriptionIcon /></Col>
                                                <Col xs={5} className="p-0 pt-1">Overview </Col>
                                                <Col xs={4} className="text-right"><CheckCircleIcon /></Col>
                                            </Row>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="second"  >
                                            <Row className="m-0">
                                                <Col xs={3} ><HelpIcon /></Col>
                                                <Col xs={5} className="p-0 pt-1">Question </Col>
                                                <Col xs={4} className="text-right"><CheckCircleIcon /></Col>
                                            </Row>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col sm={9} id="job-tab-content-container">
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Overview data={this.state.updatedJobPost} callBackFun={this.callBackFun} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second" >
                                        <Questions data={this.state.updatedJobPost} callBackFun={this.callBackFun}/>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Container>
            </div>
        )
    }
}

export default withRouter(CreateJob);